// src/modules/app-views/_apps/appsindico/unitProfiles/pages/Document/actions/actionButton.js

const unitProfilesDocumentActionButton = () => {
  return {
    action: null,
    hideButton: true,
    dropdownItems: [],
  };
};

export default unitProfilesDocumentActionButton;
